import React from 'react';

export function StarHalfIcon(props: JSX.IntrinsicElements['svg']) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 29 28"
            width="29"
            height="28"
            {...props}
        >
            <path
                fill="currentColor"
                d="M9.01 16.86L5.51 27.3l8.89-6.47 8.9 6.47-3.52-10.44 9.02-6.43H17.78L14.4 0l-3.38 10.43H0l9.01 6.43zm5.39-13.4l2.64 8.09h8.42l-6.95 4.9 2.74 8.04-6.85-4.98V3.46z"
            />
        </svg>
    );
}
